<template>
  <div class="jl-account-info-wrap">
    <div class="jl-acc-info-box">
      <div class="item-main">
        <h2>修改密码</h2>
        <div class="main-info">
          <div class="main-info-form">
            <div class="form-ground">
              <label class="form-label">旧密码</label>
              <div class="form-box">
                <input
                  type="password"
                  v-model="form.oldPassword"
                  :class="[rules.oldPassword.isError?'form-input error':'form-input']"
                  placeholder="请输入旧密码"
                  @blur="checkPassword('oldPassword')"
                />
                <div
                  v-if="rules.oldPassword.isError"
                  class="form-error"
                >{{rules.oldPassword.errorText}}</div>
              </div>
            </div>
            <div class="form-ground">
              <label class="form-label">新密码</label>
              <div class="form-box">
                <input
                  :type="[isShowPassword?'text':'password']"
                  v-model="form.nexPassword"
                  :class="[rules.nexPassword.isError?'form-input error':'form-input']"
                  placeholder="请输入新密码"
                  @blur="checkPassword('nexPassword')"
                />
                <div class="pass-icon" @click="isShowPassword =!isShowPassword">
                  <i :class="[isShowPassword?'jl-icon-eye active':'jl-icon-eye']"></i>
                </div>
                <div
                  v-if="rules.nexPassword.isError"
                  class="form-error"
                >{{rules.nexPassword.errorText}}</div>
              </div>
            </div>
            <div class="form-ground">
              <label class="form-label">确认密码</label>
              <div class="form-box">
                <input
                  :type="[isShowConfimPassword?'text':'password']"
                  v-model="form.confimPassword"
                  :class="[rules.confimPassword.isError?'form-input error':'form-input']"
                  placeholder="请确认密码"
                  @blur="checkConfimPassword('confimPassword')"
                />
                <div class="pass-icon" @click="isShowConfimPassword =!isShowConfimPassword">
                  <i :class="[isShowConfimPassword?'jl-icon-eye active':'jl-icon-eye']"></i>
                </div>
                <div
                  v-if="rules.confimPassword.isError"
                  class="form-error"
                >{{rules.confimPassword.errorText}}</div>
              </div>
            </div>
            <div class="form-ground code">
              <label class="form-label">验证码</label>
              <div class="form-box">
                <div style="position: relative;">
                  <input
                    type="text"
                    v-model="form.code"
                    :class="[rules.code.isError?'form-input error':'form-input']"
                    placeholder="请输入验证码"
                    @blur="checkCode('code')"
                  />
                  <div
                    :class="[boolSendCode?'form-send-code':'form-send-code disabled'] "
                    @click="sendCode"
                  >{{sendBtnText}}</div>
                </div>
                <div v-if="rules.code.isError" class="form-error">{{rules.code.errorText}}</div>
              </div>
            </div>
            <div class="form-ground">
              <p>注：密码长度为6～16位，数字，字母，字符至少含两种</p>
            </div>
            <div class="form-ground">
              <button class="btn" @click="submit">
                保存
                <span class="jl-loading" v-if="isLoading">
                  <i class="jl-icon-loading"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-setPhoneModal
      :phone="userInfo.phone"
      :showModal="isShowModal"
      :isModify="isModify"
      :userId="userInfo.userId"
      @cancel="cancelModal"
      @confim="confimModal"
    ></v-setPhoneModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setPassword, getVerifyCode } from "../../../api/user";
import SetPhoneModal from "../../../components/SetPhoneModal";
export default {
  name: "informationResetPassword",
  components: {
    "v-setPhoneModal": SetPhoneModal
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      isShowModal: false, //是否显示绑定手机模态框
      isModify: false, // true=>是修改  false => 绑定
      phone: "",
      form: {
        oldPassword: "",
        nexPassword: "",
        confimPassword: "",
        code: ""
      },
      rules: {
        oldPassword: {
          isError: false,
          errorText: "",
          text1: "请输入旧密码",
          text2: "密码长度为6～16位，数字，字母，字符至少含两种"
        },
        nexPassword: {
          isError: false,
          errorText: "",
          text1: "请输入新密码",
          text2: "密码长度为6～16位，数字，字母，字符至少含两种"
        },
        confimPassword: {
          isError: false,
          errorText: "",
          text1: "请确认密码",
          text2: "两次密码输入不一致"
        },
        code: {
          isError: false,
          errorText: "",
          text1: "请输入验证码",
          text2: "验证码不正确"
        }
      },
      sendBtnText: "获取验证码",
      boolSendCode: true,
      isShowPassword: false,
      isShowConfimPassword: false,
      isLoading: false
    };
  },
  created() {
    this.phone = this.userInfo.phone;
  },
  methods: {
    cancelModal() {
      this.isShowModal = false;
      document.body.className = "";
    },
    confimModal(val) {
      if (val) {
        this.userInfo.phone = val;
        this.$store.dispatch("setUserInfo", this.userInfo);
        this.isShowModal = false;
        document.body.className = "";
      }
    },
    submit() {
      let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!this.userInfo.phone) {
        this.isShowModal = true;
        this.isModify = false;
      } else {
        if (!regPhone.test(this.userInfo.phone)) {
          this.isShowModal = true;
          this.isModify = true;
        } else {
          if (!this.form.oldPassword) {
            this.rules["oldPassword"].isError = true;
            this.rules["oldPassword"].errorText = this.rules[
              "oldPassword"
            ].text1;
          }
          this.checkPassword("oldPassword");
          this.checkPassword("nexPassword");
          this.checkConfimPassword("confimPassword");
          this.checkCode("code");
          let arr = Object.keys(this.rules);
          for (const key of arr) {
            if (this.rules[key].isError) {
              return false;
            }
          }
          this.isLoading = true;
          setPassword(this, () => {});
        }
      }
    },
    checkPassword(val) {
      let reg = /^(?![^a-zA-Z]+$)(?!\D+$).{6,15}$/; //密码长度为6～16位，数字，字母，字符至少含两种
      if (!this.form[val]) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text1;
      } else if (!reg.test(this.form[val]) && val !== "oldPassword") {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text2;
      } else {
        this.rules[val].isError = false;
        this.rules[val].errorText = "";
      }
    },
    checkConfimPassword(val) {
      if (!this.form[val]) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text1;
      } else if (this.form.nexPassword !== this.form.confimPassword) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text2;
      } else {
        this.rules[val].isError = false;
        this.rules[val].errorText = "";
      }
    },
    checkCode(val) {
      if (!this.form[val]) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text1;
      } else {
        this.rules[val].isError = false;
        this.rules[val].errorText = "";
      }
    },
    setSendTime(val) {
      this.sendBtnText = "重新获取" + "(" + val + "s)";
      setTimeout(() => {
        if (val === 0) {
          this.sendBtnText = "获取验证码";
          this.boolSendCode = true;
        } else {
          this.setSendTime(--val);
        }
      }, 1000);
    },
    sendCode() {
      let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!this.userInfo.phone) {
        this.isShowModal = true;
        this.isModify = false;
      } else {
        if (!regPhone.test(this.userInfo.phone)) {
          this.isShowModal = true;
          this.isModify = true;
        } else {
          if (this.boolSendCode) {
            this.boolSendCode = false;
            getVerifyCode(this);
            this.setSendTime(60);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-acc-info-box {
  position: relative;
  .item-main {
    position: relative;
    z-index: 10;
    background: #fff;
    min-height: 450px;
    box-shadow: 9px 0 14px rgba($color: #b8b8b8, $alpha: 0.1);
  }
  .item-main {
    padding: 25px 50px;
    h2 {
      font-size: 18px;
      color: #333;
      padding-bottom: 24px;
      border-bottom: 1px dashed #e0e0e0;
    }
  }
  .main-info-form {
    padding-top: 30px;
    max-width: 590px;
    margin-left: auto;
    margin-right: auto;
    .form-ground {
      position: relative;
      padding-left: 84px;
      margin-bottom: 20px;
      .form-label {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        color: #333;
        line-height: 42px;
        &::before {
          content: "*";
          color: #e81727;
          margin-right: 4px;
        }
      }
      .form-input {
        display: block;
        width: 100%;
        height: 42px;
        background: transparent;
        border: 1px solid #ccc;
        padding: 0 13px;
        padding-right: 20px;
        &.error {
          border-color: #e81727;
        }
      }
      .btn {
        width: 100px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        background: #e81727;
        cursor: pointer;
        margin-top: 30px;
      }
      .form-error {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        margin-top: 5px;
        font-size: 12px;
        color: #e81727;
        line-height: 1;
        padding-left: 20px;
        background: url("../../../assets/img/zkj-form-tips.png") no-repeat left
          center;
        background-size: 12px;
      }
      &.code {
        .form-input {
          padding-right: 120px;
        }
        .form-send-code {
          position: absolute;
          right: 0;
          top: 50%;
          height: 26px;
          line-height: 26px;
          margin-top: -13px;
          font-size: 14px;
          color: #328aff;
          padding: 0 26px;
          cursor: pointer;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 25px;
            background: #e0e0e0;
          }
          &.disabled {
            color: #ccc;
            cursor: not-allowed;
          }
        }
      }
      .form-box {
        position: relative;
      }
    }
  }
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}

.pass-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  display: block;
  width: 16px;
  height: 16px;
  transform: translateY(-50%);
  color: #999;
  cursor: pointer;
  i {
    color: #999;
  }
  i.active {
    color: #333;
  }
}
</style>
